<div class="list-item-image-wrapper">
  <app-doenkids-image class="list-item-image" [mediaItem]="{ uuid: mediaUuid, description: '' }" [preview]="true"></app-doenkids-image>
</div>
<div class="item-content flex-1 flex-col justify-around items-start" style="width: calc(100% - 116px)">
  <ng-content></ng-content>
</div>
